<template>
	<div id="app">
		<!-- 中文 -->
		<div v-if="language==1">
			<div v-if="!isPhone">
				<Header></Header>
			</div>
			<router-view></router-view>
			<div v-if="!isPhone">
				<Footer v-show="$route.meta.show"></Footer>
			</div>
			<div v-else>
				<Footer2></Footer2>
			</div>
		</div>
		<!-- 英文 -->
		<div v-if="language==2">
			<enHeader1 v-if="!isPhone"></enHeader1>
			<router-view></router-view>
			<enFooter></enFooter>
		</div>
	</div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Header from "./components/Header";
import enHeader1 from "./components/en/enHeader1";
import Footer from "./components/Footer";
import Footer2 from "./components/Footer2";
import enFooter from "./components/en/enFooter";
export default {
	name: "app",
	components: {
		Header,
		Footer,
		Footer2,
		enFooter,
		enHeader1,
	},
	data() {
		return {
			isPhone: this.$isMobile,
			ftshow2: true,
		}
	},
	computed: {
		...mapState(["language"]),
	},
	async mounted() {
		await this.$store.dispatch("getHeadList");
		await this.$store.dispatch("getLan");
		await this.$store.dispatch("getHeadList2");
	},
    async created(){
        // zhixing 1已执行 其它未执行
        if(localStorage.getItem('zhixing')!='1'){
            const res = await this.$api.nowClientIP();
            if(res.msg == '国内'){
                this.$router.replace("/");
                // this.$store.state.language = 1;
            }else{
                this.$router.replace("/en/home");
                // this.$store.state.language = 2;
            }
            localStorage.setItem('zhixing',1);
        }
    }
};
</script>

<style lang="scss">
@import "@/common/common.scss";
#app {
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #333;
}
</style>
